import { Injectable } from '@angular/core';
import { DeviceSettingsFeatureToggle } from 'src/app/enums/feature-toggle.enum';
import { FeatureToggleService } from '../../feature-toggle/feature-toggle.service';
import { AudioSmartSettingsCapabilityService } from './audio-smart-settings-capability/audio-smart-settings-capability.service';

@Injectable({
	providedIn: 'root',
})
export class AudioSmartSettingsService {
	constructor(
		private featureToggleService: FeatureToggleService,
		private capability: AudioSmartSettingsCapabilityService
	) {}

	public getFeatureToggle() {
		return this.featureToggleService.isDeviceSettingsFeatureAvailable(
			DeviceSettingsFeatureToggle.AudioSmartSettings
		);
	}

	public getCapability(): Promise<boolean> {
		return this.capability.get();
	}
}
